import { ROUTES } from "shared/constants";

export const isIframe = (route: string) =>
  route === ROUTES.IFRAME || route === ROUTES.LOW_COST_SEARCH;
